module.exports = __webpack_public_path__ + "img/register-bg.e35e94f1.jpg";